export default __webpack_public_path__ + "static/evm-2-83825fbab8069a7310edd88db1e63839.png";